import * as accessors from './Accessors'
import * as Cells from './Cells'

export const vehicleStatsByCompany = {
    accessors,
    Cells,
}
